import React, { useState } from "react";
import { FaBook, FaHeartbeat, FaSignOutAlt } from "react-icons/fa";
import {
  TbChartInfographic,
  TbLayoutGridAdd,
  TbChecklist,
} from "react-icons/tb";
import { BiLogIn } from "react-icons/bi";
import { IoIosArrowDropright, IoIosArrowDropleft } from "react-icons/io";
import Main from "../components/main";
import { Link } from "react-router-dom";
import {
  activeMenu,
  activeStanding,
  activeText,
  activeToggle,
} from "../utils/helper";
import Logo from "../assets/images/normal_logo.png";

import MainAdmin from "../components/MainAdmin";
import { useAuth } from "../services/authProvider";

function AdminLayout({ setLocale }) {
  const { logout } = useAuth();
  const [rtl, setRtl] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [image, setImage] = useState(true);
  const [toggled, setToggled] = useState(false);
  const clinicalSite = localStorage.getItem("clinical_site");

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleRtlChange = (checked) => {
    setRtl(checked);
    setLocale(checked ? "ar" : "en");
  };
  const handleImageChange = (checked) => {
    setImage(checked);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className="app">
      <div
        className={`sidebar pb-2 shadow ${
          collapsed == true ? "collapsed" : "uncollapsed"
        }`}
      >
        <ul className="list-group">
          <div className="logo_img">
            <img
              src={Logo}
              className="img-fluid"
              width={119}
              height={60}
              alt=""
            />
          </div>
          <li>
            <Link
              to={"/admin/dashboard"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/dashboard"
              )} noHover2`}
            >
              <i
                className={`fa fa-dashboard icon-small ${
                  activeText("/admin/dashboard") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/dashboard") && "text-white"
                  }`}
                >
                  Dashboard
                </small>
              )}
            </Link>
          </li>
          <li>
            <Link
              to={"/admin/clinicalsites"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/clinicalsites"
              )} ${activeMenu("/admin/clinical_site")} noHover2`}
            >
              <i
                className={`fa fa-edit icon-small ${
                  activeText("/admin/clinicalsites") && "text-white"
                } ${activeText("/admin/clinical_site") && "text-white"}`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/clinicalsites") && "text-white"
                  } ${activeText("/admin/clinical_site") && "text-white"}`}
                >
                  Clinical Sites
                </small>
              )}
            </Link>
            {!collapsed && (
              <div
                className={`ml-3 rounded-right bg_dark ${
                  activeToggle("/admin/clinical_site", "/admin/clinicalsites")
                    ? "d-block"
                    : "d-none"
                }`}
              >
                {clinicalSite ? (
                  <Link
                    className="noHover h-40"
                    to={`/admin/clinical_site/details/${clinicalSite}`}
                  >
                    <div
                      className={`pl-4 py-2 noHover ${
                        activeToggle("/admin/clinical_site/details")
                          ? "bg_active_menu rounded-right"
                          : ""
                      }`}
                    >
                      <small className="f-11">Clinical Site Homepage</small>
                    </div>
                  </Link>
                ) : (
                  <div
                    className={`pl-4 py-2 h-40 ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : ""
                    }`}
                  >
                    <small className="text_small text-muted f-11">
                      Clinical Site Homepage
                    </small>
                  </div>
                )}
                {/* <Link
                  className="noHover h-40"
                  to={`/admin/clinical_site/details/${clinicalSite}`}
                >
                  <div
                    className={`pl-4 py-2 noHover ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : "text-muted"
                    }`}
                  >
                    <small className="f-11">Locations</small>
                  </div>
                </Link>
                <Link
                  className="noHover h-40"
                  to={`/admin/clinical_site/details/${clinicalSite}`}
                >
                  <div
                    className={`pl-4 py-2 noHover ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : "text-muted"
                    }`}
                  >
                    <small className="f-11">Users</small>
                  </div>
                </Link>
                <Link
                  className="noHover h-40"
                  to={`/admin/clinical_site/details/${clinicalSite}`}
                >
                  <div
                    className={`pl-4 py-2 noHover ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : "text-muted"
                    }`}
                  >
                    <small className="f-11">Patients</small>
                  </div>
                </Link>
                <Link
                  className="noHover h-40"
                  to={`/admin/clinical_site/details/${clinicalSite}`}
                >
                  <div
                    className={`pl-4 py-2 noHover ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : "text-muted"
                    }`}
                  >
                    <small className="f-11">Positions</small>
                  </div>
                </Link>
                <Link
                  className="noHover h-40"
                  to={`/admin/clinical_site/details/${clinicalSite}`}
                >
                  <div
                    className={`pl-4 py-2 noHover ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : "text-muted"
                    }`}
                  >
                    <small className="f-11">Functional Checklists</small>
                  </div>
                </Link>
                <Link
                  className="noHover h-40"
                  to={`/admin/clinical_site/details/${clinicalSite}`}
                >
                  <div
                    className={`pl-4 py-2 noHover ${
                      activeToggle("/hcp/patient/details")
                        ? "bg_active_menu rounded-right"
                        : "text-muted"
                    }`}
                  >
                    <small className="f-11">Reports</small>
                  </div>
                </Link> */}
              </div>
            )}
          </li>
          <li>
            {" "}
            <Link
              to={"/admin/manage_users"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/manage_users"
              )} noHover2`}
            >
              <i
                className={`fa fa-users icon-small ${
                  activeText("/admin/manage_users") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/manage_users") && "text-white"
                  }`}
                >
                  Users
                </small>
              )}
            </Link>
          </li>
          <li>
            <Link
              to={"/admin/manage_patients"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/manage_patients"
              )} noHover2`}
            >
              <i
                className={`fa fa-heartbeat icon-small ${
                  activeText("/admin/manage_patients") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/manage_patients") && "text-white"
                  }`}
                >
                  Patients
                </small>
              )}
            </Link>
          </li>
          {/* <li>
            {" "}
            <Link
              to={"#"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/patient/outstanding"
              )} noHover2`}
            >
              <i
                className={`fa fa-stethoscope icon-small ${
                  activeText("/patient/outstanding") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/patient/outstanding") && "text-white"
                  }`}
                >
                  Positions
                </small>
              )}
            </Link>
          </li> */}
          <li>
            {" "}
            <Link
              to={"/admin/manage_functional_checklists"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/manage_functional_checklists"
              )} noHover2`}
            >
              <i
                className={`fa fa-list icon-small ${
                  activeText("/admin/manage_functional_checklists") &&
                  "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/manage_functional_checklists") &&
                    "text-white"
                  }`}
                >
                  Functional Checklists
                </small>
              )}
            </Link>
          </li>
          <li>
            <Link
              to={"/admin/manage_admissions"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/manage_admissions"
              )} noHover2`}
            >
              <i
                className={`fa fa-files-o icon-small ${
                  activeText("/admin/manage_admissions") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/manage_admissions") && "text-white"
                  }`}
                >
                  Admissions
                </small>
              )}
            </Link>
          </li>
          <li>
            <Link
              to={"/admin/profile/personal_details"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/admin/profile"
              )} noHover2`}
            >
              <i
                className={`fa fa-user icon-small ${
                  activeText("/admin/profile") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/admin/profile") && "text-white"
                  }`}
                >
                  Profile
                </small>
              )}
            </Link>
          </li>
        </ul>
        {/* <div className='m-4'> */}
        <a
          href="#"
          className="noHover2 mb-2 mx-2 px-4 py-2"
          onClick={() => logout()}
        >
          <FaSignOutAlt /> &nbsp; {!collapsed && <small>Log Out</small>}
        </a>
        {/* </div> */}
      </div>
      <div className="w-100">
        <MainAdmin handleCollapsedChange={handleCollapsedChange} />
      </div>
    </div>
  );
}

export default AdminLayout;
